import type { NProgressOptions } from 'nprogress'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

/** 读取 element-plus 主题色，用于设置进度条颜色 */
const getPrimaryColor = () => {
  return (
    getComputedStyle(document.documentElement).getPropertyValue('--el-color-primary').trim() ||
    '#409eff'
  )
}

export const useNProgress = () => {
  NProgress.configure({ showSpinner: false } as NProgressOptions)

  const initColor = async () => {
    await nextTick()
    const bar = document.getElementById('nprogress')?.getElementsByClassName('bar')[0] as
      HTMLElement | undefined
    if (bar) {
      bar.style.background = getPrimaryColor()
    }
  }

  initColor()

  const start = () => {
    NProgress.start()
  }

  const done = () => {
    NProgress.done()
  }

  return {
    start,
    done
  }
}
